import React, { useState } from 'react';
import { Accordion } from 'react-bootstrap';

import * as Helper from '../Helpers/PresetHelper';
import { WeatherStationGroup } from './WeatherStationGroup';

/**
 * WeatherSection is a React component responsible for displaying weather station data
 * within an Accordion. Each weather station's data can be expanded or collapsed.
 *
 * @param {Object} data - Data containing a single data graph.
 * @param {React.Ref} ref - A React ref that can be forwarded to child components.
 * @returns {React.Component} A React component representing the WeatherSection.
 */
export const WeatherSection = React.forwardRef((props, ref) => {
  const [activeStationKey, setActiveStationKey] = useState(null);

  /**
   * Handle manual station toggle to expand or collapse a weather station section.
   *
   * @param {string} eventKey - The unique key of the weather station section.
   */
  const handleManualStationToggle = (eventKey) => {
    setActiveStationKey(activeStationKey === eventKey ? null : eventKey);
  };

  // We need to organize the graph filters into their respective weather stations
  const groupedData = {
    ...props.data,
    PersistentGraphFilters: Helper.groupFiltersByWeatherStation(props.data.PersistentGraphFilters),
  };

  return (
    <Accordion activeKey={activeStationKey}>
      {Object.keys(groupedData.PersistentGraphFilters).map((weatherStationId, idx) => (
        <WeatherStationGroup
          key={weatherStationId} // Add a unique key prop
          weatherStationId={weatherStationId}
          index={idx}
          stationData={groupedData}
          data={props.data}
          ref={ref}
          toggle={handleManualStationToggle}
          activeKey={activeStationKey}
          setActiveKey={setActiveStationKey}
          formik={props.formik}
          dataGraphIndex={props.dataGraphIndex}
          readOnly={props.readOnly}
        />
      ))}
    </Accordion>
  );
});

// Display name for the component
WeatherSection.displayName = 'WeatherSection';
